<script lang="ts">
  import FacebookIcon from 'src/icons/FacebookIcon.svelte';
  import GoogleIcon from 'src/icons/GoogleIcon.svelte';
  import RavelyIcon from 'src/icons/RavelyIcon.svelte';

  export let type: string;
  export let originUrl: string;

  const acceptedTypes = ['RAVELY', 'FACEBOOK', 'GOOGLE'];
  $: shouldDisplay = acceptedTypes.includes(type);

  const appendClassMap = {
    FACEBOOK: 'fbSourceIconWrapper',
    GOOGLE: 'googleSourceIconWrapper',
    RAVELY: 'ravelySourceIconWrapper',
  };

  $: appendedClass = appendClassMap[type] || '';
</script>

{#if shouldDisplay}
  <a href={originUrl} target="_blank" class="iconWrapper {appendedClass}">
    {#if type === 'FACEBOOK'}
      <FacebookIcon class="icon" />
    {:else if type === 'GOOGLE'}
      <GoogleIcon class="icon" />
    {:else if type === 'RAVELY'}
      <RavelyIcon class="icon" />
    {/if}
  </a>
{/if}

<style lang="scss">
  .iconWrapper {
    display: inline-block;
    cursor: pointer;
    background-color: white;
    border-radius: 50%;

    & > :global(.icon) {
      fill: var(--light-1);
    }
  }

  .fbSourceIconWrapper {
    margin-top: -0.5rem;
    height: 13px;
    width: 13px;
  }

  .googleSourceIconWrapper {
    margin-top: -0.5rem;
    height: 12px;
    width: 12px;
  }

  .ravelySourceIconWrapper {
    margin-top: -0.5rem;
    height: 13px;
    width: 13px;
  }
</style>
